<template>
  <div
    id="pz-player"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-custom"
      :class="{ 'modal-fullscreen': isFullscreen }"
      role="document"
    >
      <div class="modal-content" v-if="video && !isMobile">
        <div
          class="modal-header justify-content-between align-items-center px-2 py-1 bg-light"
        >
          <div class="flex-grow-1 w-0 text-truncate">
            <ul
              class="list-inline mb-0 d-flex align-items-center text-truncate"
            >
              <li class="list-inline-item border-right pr-0 pr-md-2">
                <button
                  type="button"
                  class="btn btn-light text-secondary d-flex"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="closePlayer"
                >
                  <i class="pz-icon icon-cancel mr-1"></i>
                  <span class="d-none d-md-inline-block">退出</span>
                </button>
              </li>
              <li class="list-inline-item ml-2 ml-md-3 text-truncate">
                <h5
                  class="modal-title text-truncate f-xs-14"
                  id="exampleModalLongTitle"
                >
                  {{ video.bulletName }}
                </h5>
              </li>
            </ul>
          </div>
          <ul class="list-inline mb-0">
            <li class="list-inline-item mx-0 mx-lg-2">
              <button
                type="button"
                class="btn btn-light text-secondary d-flex flex-column"
                @click="resizeModal()"
              >
                <i
                  class="pz-icon"
                  :class="`${
                    isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'
                  }`"
                ></i>
                <small class="d-none d-md-inline-block text-nowrap">{{
                  isFullscreen ? '恢复' : '全屏'
                }}</small>
              </button>
            </li>
          </ul>
        </div>
        <div class="modal-body p-0">
          <div class="collapse-column collapse" style ref="modalPlay">
            <div class="collapse-column-left notepad">
              <note
                :video="video"
                :onNoteSaved="onNoteSaved"
                :typeOfEditor="'VIDEO_NOTE'"
                v-if="notable && isOpened && isShowNote"
              />
            </div>
            <div class="collapse-column-right overflow-hidden">
              <div
                id="fromZhihuFlag"
                v-if="video.vpathFree && !userInfo.hasPay"
                class="alert alert-warning p-2 mb-0 small border-0"
                style="z-index: 999; border-radius: 0"
              >
                <strong>本视频来自于知乎,地址为:</strong>
                <span class="text-break" style="text-decoration: underline">{{
                  URI
                }}</span
                >.
                <button
                  type="button"
                  class="btn btn-link btn-sm small px-0 f-12"
                  @click="copyUrl"
                >
                  前往
                </button>
              </div>
              <div id="class-v2-polyv" ref="polyvContainer"></div>
            </div>
          </div>
        </div>
        <div
          class="modal-footer bg-light justify-content-between"
          v-if="isShowFooter || notable || markable || switchable"
        >
          <div class="modal-footer-left">
            <ul class="list-inline mb-0">
              <li class="list-inline-item" v-if="notable">
                <button
                  type="button"
                  data-toggle="collapse"
                  data-target=".collapse-column"
                  aria-expanded="false"
                  aria-controls="collapse-column"
                  class="btn btn-link text-secondary btn-note-player collapsed d-flex text-decoration-none"
                  @click="toggleNote"
                >
                  <i class="pz-icon icon-create mr-1"></i>
                  <span class="d-none d-md-inline-block">笔记</span>
                </button>
              </li>
              <li class="list-inline-item" v-if="markable">
                <button
                  type="button"
                  data-toggle="button"
                  aria-pressed="false"
                  autocomplete="off"
                  class="btn btn-link text-secondary btn-bookmark d-flex text-decoration-none"
                  :class="{
                    active: video.collected,
                  }"
                  @click="mark"
                >
                  <i class="pz-icon icon-bookmark mr-1"></i>
                  <span class="d-none d-md-inline-block">收藏</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  type="button"
                  data-toggle="collapse"
                  data-target="#pz-video-report"
                  aria-expanded="false"
                  aria-controls="pz-video-report"
                  class="btn btn-link text-secondary d-flex text-decoration-none"
                  @click="showVideoReport"
                >
                  <i class="pz-icon icon-error mr-1"></i>
                  <span class="d-none d-md-inline-block">纠错</span>
                </button>
              </li>
            </ul>
          </div>
          <div class="modal-footer-right">
            <div class="dropdown dropup mr-3" v-show="isShowSpeed">
              <button
                class="btn btn-light"
                type="button"
                id="triggerId"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                倍数：{{ getSpeed(defaultSpeed) }}X
              </button>
              <div class="dropdown-menu" aria-labelledby="triggerId">
                <a
                  href="#"
                  class="dropdown-item"
                  :class="{ active: defaultSpeed === 0 }"
                  @click="changeSpeed(0)"
                  >1X</a
                >
                <a
                  href="#"
                  class="dropdown-item"
                  :class="{ active: defaultSpeed === 1 }"
                  @click="changeSpeed(1)"
                  >1.3X</a
                >
                <a
                  href="#"
                  class="dropdown-item"
                  :class="{ active: defaultSpeed === 2 }"
                  @click="changeSpeed(2)"
                  >1.5X</a
                >
                <a
                  href="#"
                  class="dropdown-item"
                  :class="{ active: defaultSpeed === 3 }"
                  @click="changeSpeed(3)"
                  >2X</a
                >
              </div>
            </div>
            <div
              class="mr-3 d-none d-md-flex"
              v-if="userInfo && userInfo.profile && continuable"
            >
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="turnOnContinuous"
                  id="customSwitch2"
                />
                <label class="custom-control-label" for="customSwitch2"
                  >连续播放</label
                >
              </div>
            </div>
            <button
              v-if="switchable && !video.isLatest"
              type="button"
              class="btn btn-primary px-lg-4"
              @click="goToNextVideo"
              @keydown.prevent
              @keypress.prevent
              @keyup.prevent
            >
              下一视频
            </button>
          </div>
        </div>
        <qa
          :video="video"
          @qa-opened="handleQaOpened"
          :typeOfEditor="'VIDEO_QA'"
          v-if="qable && isOpened"
        />
        <video-report :video="video" />
      </div>

      <div class="modal-content" v-if="isMobile">
        <div
          class="modal-header justify-content-between align-items-center px-2 py-1 bg-light"
        >
          <div class="flex-grow-1 w-0 text-truncate">
            <ul
              class="list-inline mb-0 d-flex align-items-center text-truncate"
            >
              <li class="list-inline-item border-right pr-0 pr-md-2">
                <button
                  type="button"
                  class="btn btn-light text-secondary d-flex"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="closePlayer"
                >
                  <i class="pz-icon icon-cancel mr-1"></i>
                  <span class="d-none d-md-inline-block">退出</span>
                </button>
              </li>
              <li class="list-inline-item ml-2 ml-md-3 text-truncate">
                <h5
                  class="modal-title text-truncate f-xs-14"
                  id="exampleModalLongTitle"
                >
                  {{ video.bulletName }}
                </h5>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="modal-body d-flex flex-column justify-content-center align-items-center"
        >
          <div
            class="text-danger text-center mb-4 mt-n5"
            style="max-width: 500px"
          >
            <!-- {{ mobileText }} -->
            出于安全和用户隐私的考量，请使用苹果(IOS)、安卓(Android)的App，或者请在PC点电脑上使用最新版本的Chrome或Edge或Safari浏览器再访问本网站以获得更好的使用体验。
          </div>

          <div class="d-flex flex-column flex-md-row">
            <a
              class="ios-app-btn m-2"
              target="_blank"
              href="https://apps.apple.com/cn/app/id1480840214?l=zh&ls=1"
            >
              <img
                src="https://resources.pzacademy.com/image/class-ui/ios-app.png"
                width="150"
                height="50"
                alt="IOS Store"
              />
            </a>

            <a
              class="android-app-btn m-2"
              href="http://class.pzacademy.com/download/pzacademy.apk"
            >
              <img
                src="https://resources.pzacademy.com/image/class-ui/android-app.png"
                width="150"
                height="50"
                alt="IOS Store"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { debounce } from 'lodash';
import Swal from 'sweetalert2';
import { mapState, mapGetters, mapActions } from 'vuex';

import { MOBILE_SUPPORTED_TEXT } from '@/constants';
import { getIsMobile } from '@/utils/browser';
import {
  onVideoStarted,
  onVideoPaused,
  onVideoStopped,
  onBulletStarted,
  onBulletFinished,
  onGetVideoToken,
  onGetPublicKey,
  onVideoChangeSpeed,
  onVideoLastProgress,
  onMarqueeQuickCheck,
} from '@/global/service';
import { PlayerNoteQaContainerMixin } from '@/mixins/NoteQA/container/PlayerNoteQaContainer';
import { VideoReportMixin } from '@/mixins/Survey/VideoReport';

// const polyvObject = window.polyvObject;
const polyvPlayer = window.polyvPlayer;

export default {
  name: 'Player',

  mixins: [PlayerNoteQaContainerMixin, VideoReportMixin],

  props: {
    video: Object,

    notable: {
      type: Boolean,
      default: () => false,
    },

    onNoteSaved: {
      type: Function,
      default: () => {},
    },

    namable: {
      type: Boolean,
      default: () => false,
    },

    markable: {
      type: Boolean,
      default: () => false,
    },

    continuable: {
      type: Boolean,
      default: () => true,
    },

    isShowFooter: {
      type: Boolean,
      default: () => false,
    },

    isShowSpeed: {
      type: Boolean,
      default: () => true,
    },

    switchable: {
      type: Boolean,
      default: () => false,
    },

    isPlayerFullscreen: {
      type: Boolean,
      default: () => false,
    },

    visiable: {
      type: Boolean,
      default: () => false,
    },

    isVideoMode: {
      type: Boolean,
      default: () => false,
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    onNext: {
      type: Function,
      default: () => {},
    },

    onMark: {
      type: Function,
      default: () => {},
    },

    onChangeBulletStatus: {
      type: Function,
      default: () => {},
    },

    onSetLastProgress: {
      type: Function,
      default: () => {},
    },

    p_startTime: {
      type: Number,
      default: -1,
    },
  },

  player: null,

  data() {
    return {
      continuous: false,
      // player: null,
      showMessage: false,
      messageContext: '',
      timer: null,
      // speed: 1,
      playing: false,
      startTime: 0,
      isFullscreen: false,
      fatigueTimer: null,
      screenXYTimer: null,
      fatigueDuration: 1000 * 60 * 60,
      isMobile: false,
      mobileText: MOBILE_SUPPORTED_TEXT,
      marqueeArr: [],

      isOpened: false,
      isShowNote: false,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      userInfo: 'userInfo',
    }),

    defaultSpeed: function () {
      return this.userInfo && this.userInfo.defaultSpeed;
    },

    turnOnContinuous: {
      get: function () {
        return (
          this.userInfo &&
          this.userInfo.profile &&
          this.userInfo.profile.turnOnContinuous
        );
      },
      set: function (turnOnContinuous) {
        this.updateProfile({ turnOnContinuous });
      },
    },
    URI: function () {
      return `https://pzacademy.zhihu.com/complimentary/video/${
        this.video.vpathFree
      }/${encodeURI(this.video.bulletName)}`;
    },
  },

  watch: {
    visiable: function (v) {
      if (v) {
        $(`#pz-player`).modal({ backdrop: 'static', keyboard: false });
      }
    },
  },

  created() {
    this.isFullscreen = this.isPlayerFullscreen;
  },

  mounted() {
    setTimeout(() => {
      $('#fromZhihuFlag').alert('close');
    }, 10000);
    if (getIsMobile()) {
      this.isMobile = true;
      return;
    }
    $(`#pz-player`)
      .on('show.bs.modal', async () => {
        const vid = this.getVidBySpeed(
          this.isShowSpeed ? this.defaultSpeed : 1
        );
        let time = 0;
        const lastProgress = this.video.lastProgress;
        if (lastProgress) {
          if (this.video.videoSpeed === this.defaultSpeed) {
            time = this.video.lastProgress;
          } else {
            time =
              (this.video.lastProgress / this.getSpeed(this.defaultSpeed)) *
              this.getSpeed(this.video.videoSpeed);
          }
        }
        this.toPlay(vid, time);
        this.isOpened = true;
      })
      .on('hide.bs.modal', () => {
        this.isOpened = false;
      });

    window.s2j_onVideoPause = debounce((vid, ended) => {
      if (ended || this.$options.player.getVideoEnded()) {
        return;
      }
      if (
        this.userInfo.studentId &&
        this.$options.player &&
        this.$options.player.j2s_getCurrentTime
      ) {
        const progress = parseInt(this.$options.player.j2s_getCurrentTime());
        const vid = this.getVidBySpeed(this.defaultSpeed);
        onVideoPaused({
          bulletId: this.video.bulletId,
          videoId: this.video.videoId,
          vpath: vid,
          videoSpeed: this.defaultSpeed,
          lastProgress: progress,
        });
        this.cancelFatigueTimer();
      }
    });

    window.s2j_onPlayOver = debounce(() => {
      // console.log(this.video, 's2j_onPlayOver');
      this.playing = false;
      if (this.userInfo.studentId) {
        const vid = this.getVidBySpeed(this.defaultSpeed);
        onVideoStopped({
          bulletId: this.video.bulletId,
          videoId: this.video.videoId,
          vpath: vid,
        });
        this.$options.player.j2s_seekVideo(0);
        if (this.video.bulletStatus !== 2) {
          onBulletFinished({
            courseId: this.video.courseId,
            bulletId: this.video.bulletId,
          });
          this.onChangeBulletStatus(this.video, 2);
        }
        if (this.isOpened && this.turnOnContinuous && !this.video.isLatest) {
          this.goToNextVideo();
        }
      }
    });

    window.s2j_onPlayStart = () => {
      if (this.startTime > 0) {
        this.$options.player.j2s_seekVideo(this.startTime);
        if (this.userInfo.studentId) {
          onVideoChangeSpeed({
            videoSpeed: this.defaultSpeed,
          });
        }
      }
      if (this.userInfo.studentId) {
        if (this.video.bulletStatus === 0) {
          onBulletStarted({
            courseId: this.video.courseId,
            bulletId: this.video.bulletId,
          });
          this.onChangeBulletStatus(this.video, 1);
        }
      }
    };

    window.s2j_onVideoPlay = debounce(() => {
      // const _this = this;
      this.playing = true;
      if (this.userInfo.studentId) {
        const vid = this.getVidBySpeed(this.defaultSpeed);
        onVideoStarted({
          bulletId: this.video.bulletId,
          videoId: this.video.videoId,
          vpath: vid,
          videoMode: this.isVideoMode,
        });
        if (!this.fatigueTimer && this.turnOnContinuous) {
          this.fatigueTimer = setTimeout(() => {
            this.$options.player.j2s_pauseVideo();
            Swal.fire({
              title: '休息一下吧',
              text: '您已经累计连续学习了60分钟啦！',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: '休息一下',
              cancelButtonText: '继续学习',
            }).then(async (result) => {
              if (result.value) {
                this.closePlayer();
              } else {
                this.$options.player.j2s_resumeVideo();
              }
            });
          }, this.fatigueDuration);
        }
      }
    });

    window.s2j_onPlayerInitOver = () => {
      if (this.p_startTime >= 0) {
        this.startTime = this.p_startTime;
        this.$options.player.j2s_seekVideo(this.startTime);
        this.$options.player.j2s_resumeVideo();
      }
    };

    // this.$options.player.on('s2j_onFullScreen', (...params) => {
    //   $('.pv-logo').css({
    //     top: '0px',
    //   });
    // });
    // this.$options.player.on('s2j_onNormalScreen', (...params) => {
    //   $('.pv-logo').css({
    //     top: '55px',
    //   });
    // });
  },

  beforeDestroy() {
    if (this.$options.player) {
      this.closePlayer();
    }
  },

  methods: {
    ...mapActions({
      updateProfile: 'updateProfile',
    }),

    toggle() {
      if (!this.isFullscreen) {
        this.isFullscreen = true;
      }
    },

    cancelFatigueTimer() {
      if (this.fatigueTimer) {
        clearTimeout(this.fatigueTimer);
        this.fatigueTimer = null;
      }
    },

    resizeModal() {
      this.isFullscreen = !this.isFullscreen;
    },

    videoLastProgress() {
      if (!this.$options.player || !this.$options.player.j2s_getCurrentTime) {
        return;
      }
      const { courseId, videoId } = this.video;
      onVideoLastProgress({
        courseId: courseId,
        videoId: videoId,
        lastProgress: parseInt(this.$options.player.j2s_getCurrentTime()),
        videoSpeed: this.defaultSpeed,
      });
      this.onSetLastProgress(videoId, {
        lastProgress: parseInt(this.$options.player.j2s_getCurrentTime()),
        videoSpeed: this.defaultSpeed,
      });
    },

    toPlay(vid, time) {
      this.$nextTick(async () => {
        const {
          courseId,
          bookId,
          bulletId,
          videoId,
          showPolyvSpeed,
          start,
          end,
        } = this.video;
        const token = await onGetVideoToken({
          courseId,
          bookId,
          bulletId,
          videoId,
          vid,
        });

        let opt1 = {
          wrap: '#class-v2-polyv',
          width: '100%',
          height: '100%',
          vid,
          playsafe: token.data.data,
          marqueeCheck: true,
          // pub: publicKey.data.data,
          speed: showPolyvSpeed ? true : false,
          forceH5: true,
          hideSwitchPlayer: true,
          ignoreIE: false,
          allowGetScreenshotData: true,
        };

        if (undefined !== start) {
          opt1 = {
            ...opt1,
            start,
          };
        }
        if (undefined !== end) {
          opt1 = {
            ...opt1,
            end,
          };
        }

        let opt2 = {
          vid: vid,
          autoplay: true,
          playsafe: token.data.data,
          speed: showPolyvSpeed ? true : false,
          forceH5: true,
          hideSwitchPlayer: true,
          ignoreIE: false,
          allowGetScreenshotData: true,
        };

        let showLogo = {
          logo: {
            logo_width: 127, //Logo宽 默认 'auto'
            logo_height: 'auto', //Logo高 默认 'auto'
            logo_url: 'https://class.pzacademy.com/img/yrd.png', // Logo图片URL
            logo_pos: 2, //Logo显示位置，取值范围为：{0,1,2,3,4}，分别代表：隐藏、左上、右上、左下、右下
            logo_link: '', // 点击Logo的跳转链接 (选填)
            logo_alpha: 50, //Logo透明度，取值范围：(0,100)
            logoOffset: '4,94', //Logo偏移量，单位：百分比。坐标原点为播放器左上角，只在Logo位置为左上、右上时生效
            logo_resize: false, //默认值为false，为true时会根据播放器窗口大小动态调整Logo的尺寸，若设置了logo宽高则该参数不生效
          },
        };

        let showLogo2 = {
          logo: {
            logo_width: 127, //Logo宽 默认 'auto'
            logo_height: 'auto', //Logo高 默认 'auto'
            logo_url: 'https://class.pzacademy.com/img/lianzheng.png', // Logo图片URL
            logo_pos: 2, //Logo显示位置，取值范围为：{0,1,2,3,4}，分别代表：隐藏、左上、右上、左下、右下
            logo_link: '', // 点击Logo的跳转链接 (选填)
            logo_alpha: 50, //Logo透明度，取值范围：(0,100)
            logoOffset: '4,94', //Logo偏移量，单位：百分比。坐标原点为播放器左上角，只在Logo位置为左上、右上时生效
            logo_resize: false, //默认值为false，为true时会根据播放器窗口大小动态调整Logo的尺寸，若设置了logo宽高则该参数不生效
          },
        };

        if (courseId == '445114' || courseId == '489368') {
          opt1 = Object.assign({}, opt1, showLogo);
          opt2 = Object.assign({}, opt2, showLogo);
        }

        if (courseId == '546856') {
          opt1 = Object.assign({}, opt1, showLogo2);
          opt2 = Object.assign({}, opt2, showLogo2);
        }

        this.startTime = time;
        if (!this.$options.player) {
          this.$options.player = polyvPlayer(opt1);
          window.player = this.$options.player;
        } else {
          this.$options.player.changeVid(opt2);
        }
        if ($('object').length) {
          $('object').focus();
        }
      });
    },

    closePlayer() {
      $(`#pz-player`).modal('hide');
      if (!this.isMobile) {
        if (this.userInfo.studentId) {
          this.videoLastProgress();
        }
        if (this.$options.player) {
          this.$options.player.destroy();
          this.$options.player = null;
          window.player = null;
        }
        this.marqueeArr = [];
        this.onClose();
        $(`#class-v2-polyv`).empty();
        this.playing = false;
        this.cancelFatigueTimer();
      }
    },

    setMessage(msg) {
      this.showMessage = true;
      this.messageContext = msg;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.showMessage = false;
        clearTimeout(this.timer);
      }, 2000);
    },

    async mark() {
      const video = this.video;
      await this.onMark({
        bulletId: video.bulletId,
        toCollect: !video.collected,
      });
      this.setMessage(video.collected ? '收藏成功！' : '取消收藏成功！');
    },

    async goToNextVideo() {
      if (this.$options.player.changeVid) {
        this.onNext();
        this.videoLastProgress();
        this.$nextTick(async () => {
          const vid = this.getVidBySpeed(this.defaultSpeed);
          this.toPlay(vid, 0);
        });
      }
    },

    getVidBySpeed(speed) {
      let vid = this.video.speed1;
      switch (speed) {
        case 0:
          vid = this.video.speed1;
          break;
        case 1:
          vid = this.video.speed1Dot3;
          break;
        case 2:
          vid = this.video.speed1Dot5;
          break;
        case 3:
          vid = this.video.speed2;
          break;
        default:
          vid = this.video.speed1;
          break;
      }
      return vid;
    },

    getSpeed(speed) {
      var spd = 0;
      switch (speed) {
        case 0:
          spd = 1;
          break;
        case 1:
          spd = 1.3;
          break;
        case 2:
          spd = 1.5;
          break;
        case 3:
          spd = 2;
          break;
        default:
          spd = 1;
          break;
      }
      return spd;
    },

    async copyUrl() {
      window.location.href = this.URI;
    },

    changeSpeed(speed, time) {
      if (
        this.$options.player &&
        this.$options.player &&
        this.$options.player.j2s_getCurrentTime
      ) {
        const vid = this.getVidBySpeed(speed);
        let startTime = 0;
        if (undefined === time) {
          const currentTime = parseInt(
            this.$options.player.j2s_getCurrentTime()
          );
          if (speed == 0) {
            startTime = (currentTime / 1) * this.getSpeed(this.defaultSpeed);
          } else if (speed == 1) {
            startTime = (currentTime / 1.3) * this.getSpeed(this.defaultSpeed);
          } else if (speed == 2) {
            startTime = (currentTime / 1.5) * this.getSpeed(this.defaultSpeed);
          } else if (speed == 3) {
            startTime = (currentTime / 2) * this.getSpeed(this.defaultSpeed);
          }
        } else {
          startTime = time;
        }
        if (this.userInfo.studentId) {
          this.$store.commit('UPDATE_USER_INFO_SUCCESS', {
            defaultSpeed: speed,
          });
        }
        this.toPlay(vid, Math.floor(startTime));
        this.cancelFatigueTimer();
      }
    },

    toPause() {
      this.$options.player.j2s_pauseVideo();
    },

    toggleNote() {
      this.isShowNote = !this.isShowNote;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.video-speed {
  // position: absolute;
  width: 200px;
  height: 35px;
  // bottom: 0;
  // right: 150px;
  background: transparent;
  z-index: 1000;
}

.video-speed span {
  line-height: 35px;
  color: #000;
  margin-left: 8px;
  cursor: pointer;
}

.video-speed span.active {
  color: #669900;
}
</style>
